export default "__VITE_ASSET__Dgdsk3j$__"